import { __assign } from "tslib";
import { addRumAction } from '../hosting/dataflux-rum';
import _debounce from 'lodash/debounce';
export var startOpenFlowPerformanceStatistics = function () {
    if (window.__FLOW_START_CLICK_TIMESTAMP) {
        leaveOpenFlowCopyPerformanceStatistics(window.__FLOW_START_CLICK_TIMESTAMP);
    }
    window.__FLOW_START_CLICK_TIMESTAMP = performance.now();
    console.log('单据页面 window.__FLOW_START_CLICK_TIMESTAMP', window.__FLOW_START_CLICK_TIMESTAMP);
};
export var startOpenFlowThirdPartyPerformanceStatistics = function () {
    if (!window.__FLOW_START_CLICK_TIMESTAMP) {
        window.__FLOW_START_CLICK_TIMESTAMP = performance.now();
        startLoadFlowPerformanceStatistics();
    }
};
export var leaveOpenFlowCopyPerformanceStatistics = function (date) {
    window.__FLOW_START_CLICK_TIMESTAMP_Copy = date;
    console.log('单据页面 离开时间缓存window.__FLOW_START_CLICK_TIMESTAMP', window.__FLOW_START_CLICK_TIMESTAMP_Copy);
};
export var clearFlowPerformanceStatistics = function () {
    window.__FLOW_START_CLICK_TIMESTAMP = null;
    window.__FLOW_START_LOAD_TIMESTAMP = null;
    window.__FLOW_START_LOAD_TIMESTAMPV2 = null;
    window.__FLOW_START_CLICK_TIMESTAMP_Copy = null;
    window.__FLOW_DETAILS_RECORD = null;
};
export var endOpenFlowPerformanceStatistics = function (params) {
    if (params === void 0) { params = {}; }
    var duration = performance.now() - window.__FLOW_START_CLICK_TIMESTAMP;
    console.log('单据页面打开所需时间', performance.now(), window.__FLOW_START_CLICK_TIMESTAMP);
    if (isValidTimestamp(duration) || !window.__FLOW_START_CLICK_TIMESTAMP) {
        return;
    }
    addRumAction('open_flow_performance_statistics', __assign(__assign({ title: '单据页面打开所需时间', loadedDuration: duration, hashPath: location.hash }, params), (window.__FLOW_DETAILS_RECORD || {})));
    console.log("%c \u5355\u636E\u9875\u9762\u4ECE\u70B9\u51FB\u5230\u6253\u5F00\u6240\u9700\u65F6\u95F4:" + duration + "ms", 'color:red');
};
export var leaveFlowPerformanceStatistics = function (params) {
    if (params === void 0) { params = {}; }
    var duration = performance.now() - (window.__FLOW_START_CLICK_TIMESTAMP_Copy || window.__FLOW_START_CLICK_TIMESTAMP);
    console.log('单据页面从点击到离开所需时间', performance.now(), window.__FLOW_START_CLICK_TIMESTAMP);
    if (!(window.__FLOW_START_CLICK_TIMESTAMP_Copy || window.__FLOW_START_CLICK_TIMESTAMP))
        return;
    addRumAction('leave_flow_performance_statistics', __assign(__assign({ title: '从点击到离开所需时间', loadedDuration: duration, hashPath: location.hash }, params), (window.__FLOW_DETAILS_RECORD || {})));
    clearFlowPerformanceStatistics();
    console.log("%c \u5355\u636E\u9875\u9762\u4ECE\u70B9\u51FB\u5230\u79BB\u5F00\u6240\u9700\u65F6\u95F4:" + duration + "ms", 'color:red');
};
export var startLoadFlowPerformanceStatistics = function () {
    window.__FLOW_START_LOAD_TIMESTAMP = performance.now();
    startLoadFlowPerformanceStatisticsV2();
};
export var startLoadFlowPerformanceStatisticsV2 = function () {
    window.__FLOW_START_LOAD_TIMESTAMPV2 = performance.now();
};
export var computeComponentLoadingPeriod = function (data) {
    var duration = performance.now() - window.__FLOW_START_LOAD_TIMESTAMP;
    if (isValidTimestamp(duration) || !window.__FLOW_START_LOAD_TIMESTAMP) {
        return;
    }
    addRumAction('compute_component_loading_period', __assign({ title: '单据页面组件加载完成所需时间', loadedDuration: duration, hashPath: data.hashPath, operateType: data.operateType }, (window.__FLOW_DETAILS_RECORD || {})));
    console.log("%c \u5355\u636E\u9875\u9762[\u6A21\u7248:" + data.hashPath + ":" + data.operateType + "]\u7684\u6240\u6709\u7EC4\u4EF6\u52A0\u8F7D\u5B8C\u6210\u6240\u9700\u65F6\u95F4V2\uFF1A" + duration + "ms", 'color:red');
};
export var computeComponentLoadingPeriodV2 = function (data) {
    var duration = performance.now() - window.__FLOW_START_LOAD_TIMESTAMPV2;
    if (isValidTimestamp(duration) || !window.__FLOW_START_LOAD_TIMESTAMPV2) {
        return;
    }
    addRumAction('compute_calculate_component_loading_period', __assign({ title: '单据页面组件加载完成所需时间', loadedDuration: duration, hashPath: data.hashPath, operateType: data.operateType }, (window.__FLOW_DETAILS_RECORD || {})));
    console.log("%c \u5355\u636E\u9875\u9762[\u6A21\u7248:" + data.hashPath + ":" + data.operateType + "]\u7684\u6240\u6709\u7EC4\u4EF6\u52A0\u8F7D\u5B8C\u6210\u6240\u9700\u65F6\u95F4V2\uFF1A" + duration + "ms", 'color:red');
    window.__FLOW_START_LOAD_TIMESTAMPV2 = null;
};
export var computeUnComponentLoadingPeriod = function (data) {
    addRumAction('compute_unComponent_loading_period', {
        title: '单据页面组件卸载完成所需时间',
        fieldName: data.fieldName,
        templateId: data.templateId,
        loadedDuration: data.loadedDuration,
        fieldType: data.fieldType
    });
};
export var startSaveFlowPerformanceStatistics = function () {
    window.__FLOW_START_SAVE_TIMESTAMP = performance.now();
};
export var endFlowFormDataCollectionStatistics = function (params) {
    if (params === void 0) { params = {}; }
    var duration = performance.now() - window.__FLOW_START_SAVE_TIMESTAMP;
    if (isValidTimestamp(duration) || !window.__FLOW_START_SAVE_TIMESTAMP) {
        return;
    }
    addRumAction('end_flow_form_data_collection_statistics', __assign(__assign({ title: '单据页面数据收集完成所需时间', loadedDuration: duration, hashPath: location.hash }, params), (window.__FLOW_DETAILS_RECORD || {})));
    console.log("%c \u5355\u636E\u9875\u9762\u6570\u636E\u6536\u96C6\u5B8C\u6210\u6240\u9700\u65F6\u95F4:" + duration + "ms", 'color:red');
};
export var endFlowFormDataSubmitStatistics = function (params) {
    if (params === void 0) { params = {}; }
    var duration = performance.now() - window.__FLOW_START_SAVE_TIMESTAMP;
    if (isValidTimestamp(duration) || !window.__FLOW_START_SAVE_TIMESTAMP) {
        return;
    }
    addRumAction('end_flow_form_data_submit_statistics', __assign(__assign({ title: '单据页面数据保存or提交完成所需时间', loadedDuration: duration, hashPath: location.hash }, params), (window.__FLOW_DETAILS_RECORD || {})));
    startClickEndFlowSubmitStatistics(params);
    console.log("%c \u5355\u636E\u9875\u9762\u6570\u636E\u4FDD\u5B58or\u63D0\u4EA4\u5B8C\u6210\u6240\u9700\u65F6\u95F4:" + duration + "ms", 'color:red');
};
export var startClickEndFlowSubmitStatistics = function (params) {
    if (params === void 0) { params = {}; }
    var duration = performance.now() - window.__FLOW_START_CLICK_TIMESTAMP;
    if (!window.__FLOW_START_CLICK_TIMESTAMP) {
        return;
    }
    addRumAction('start_click_end_flow_form_data_submit_statistics', __assign(__assign({ title: '单据页面从点击到单据提交时间', loadedDuration: duration, hashPath: location.hash }, params), (window.__FLOW_DETAILS_RECORD || {})));
    console.log("%c \u5355\u636E\u9875\u9762\u4ECE\u70B9\u51FB\u5230\u5355\u636E\u63D0\u4EA4\u65F6\u95F4:" + duration + "ms", 'color:red');
};
export var startClickDimensionStatistics = function () {
    window.__FLOW_START_CLICK_DIMENSION_TIMESTAMP = performance.now();
};
export var clearClickDimensionStatistics = function () {
    window.__FLOW_START_CLICK_DIMENSION_TIMESTAMP = 0;
};
export var endDimensionLoadingPeriod = function (params) {
    if (params === void 0) { params = {}; }
    var duration = Date.now() - window.__FLOW_START_CLICK_DIMENSION_TIMESTAMP;
    addRumAction('end_dimension_loading_period', __assign({ title: '维度数据加载完成所需时间', loadedDuration: duration, hashPath: location.hash }, params));
    console.log("%c \u7EF4\u5EA6\u6570\u636E\u52A0\u8F7D\u5B8C\u6210\u6240\u9700\u65F6\u95F4:" + duration + "ms", 'color:red');
};
export var flowDetailsStatistics = function (data) {
    window.__FLOW_DETAILS_RECORD = data;
};
var isValidTimestamp = function (timestamp) {
    var tenMinutesInMilliseconds = 10 * 60 * 1000;
    return timestamp > tenMinutesInMilliseconds;
};
export var reportBillPagePaintDuration = function () {
    var report = _debounce(function (e) {
        var _a;
        var target = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest('.eui-tabs-content, #NewBillInfoView, #BillInfoView');
        if (target || (e === null || e === void 0 ? void 0 : e.type) === 'scroll') {
            document.removeEventListener('click', report, true);
            document.removeEventListener('scroll', report, true);
            if (window.__FLOW_START_LOAD_TIMESTAMP) {
                computeComponentLoadingPeriod({
                    hashPath: location.hash,
                    operateType: e === null || e === void 0 ? void 0 : e.type
                });
            }
        }
    }, 200);
    document.addEventListener('click', report, true);
    document.addEventListener('scroll', report, true);
};
export var reportBillPagePaintDurationV2 = function () {
    computeComponentLoadingPeriodV2({
        hashPath: location.hash,
        operateType: 'calculate'
    });
};
export var reportNegativeApportionMoney = function (params) {
    if (params === void 0) { params = {}; }
    addRumAction('negative_apportion_money_statistics', __assign(__assign({ title: '费用明细填写分摊负数金额数据' }, params), (window.__FLOW_DETAILS_RECORD || {})));
};
